import { config } from "./config/app"

export const API_GET_DEEP_LINK_COUPANG = `/${config.apiVersion}/recipe/coupang/deeplink/generate`
export const API_GET_COUPANG_RECO = `/${config.apiVersion}/recipe/coupang/reco`
export const API_GET_COUPANG_SEARCH = `/${config.apiVersion}/recipe/coupang/search`
export const API_GET_COUPANG_BANNER = `/${config.apiVersion}/recipe/coupang/banner`